import { ReactHTML } from 'react';

export function useHeadingIndex(index?: number): (keyof ReactHTML)[] {
  switch (index) {
    case 1:
      return ['h1', 'h2', 'h3', 'h4', 'h5'];
    case 2:
      return ['h2', 'h3', 'h4', 'h5'];
    case 3:
      return ['h3', 'h4', 'h5'];
    case 4:
      return ['h4', 'h5'];
    case 5:
      return ['h5'];
    default:
      return [];
  }
}
